// extracted by mini-css-extract-plugin
export default {"links":"styles_links__3hchJ","add":"styles_add__JKIr1","text":"styles_text__ot4jk","inputWrapper":"styles_inputWrapper__C5VGJ","removeIcon":"styles_removeIcon__fzFPt"};